import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Typography, Button } from "@material-tailwind/react";
import NewsletterSection from "../components/sections/NewsletterSection";

const PORTAL_API_BASE = (
  process.env.REACT_APP_PORTAL_API_URL ||
  "https://n4qh9nwqv5.execute-api.us-east-1.amazonaws.com/prod"
).replace(/\/$/, "");

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-MX", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return "";
  }
}

export default function ConexionSiete() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(`${PORTAL_API_BASE}/revista/issues`)
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.error || "No se pudo cargar el catálogo");
        return data;
      })
      .then((data) => {
        if (!cancelled) setIssues(Array.isArray(data?.issues) ? data.issues : []);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || "Error al cargar");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex flex-col w-full">
      <section className="bg-brand-navy text-white py-14 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <Typography variant="h2" className="font-normal text-3xl sm:text-4xl md:text-5xl mb-3">
            Conexión Siete
          </Typography>
          <Typography className="text-white/85 text-base sm:text-lg leading-relaxed max-w-xl mx-auto">
            La publicación digital de EAP Consulting. Explora las ediciones y
            suscríbete para recibir el ejemplar vigente por correo.
          </Typography>
        </div>
      </section>

      <section className="bg-brand-beige py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Typography variant="h4" className="text-brand-navy font-normal mb-6">
            Ediciones
          </Typography>

          {loading ? (
            <p className="text-brand-gray text-sm">Cargando ediciones…</p>
          ) : error ? (
            <p className="text-red-600 text-sm" role="alert">
              {error}
            </p>
          ) : issues.length === 0 ? (
            <p className="text-brand-gray text-sm">
              Pronto publicaremos el primer ejemplar. Mientras tanto puedes suscribirte abajo.
            </p>
          ) : (
            <ul className="space-y-3">
              {issues.map((issue) => (
                <li
                  key={issue.issueId || issue.downloadUrl}
                  className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-xl border border-brand-lilac/60 bg-white px-5 py-4 shadow-sm"
                >
                  <div className="min-w-0">
                    <p className="font-semibold text-brand-navy truncate">
                      {issue.title || "Conexión Siete"}
                    </p>
                    {issue.publishedAt ? (
                      <p className="text-sm text-brand-gray mt-0.5">
                        {formatDate(issue.publishedAt)}
                      </p>
                    ) : null}
                  </div>
                  <div className="flex flex-wrap gap-2 shrink-0">
                    {issue.downloadUrl ? (
                      <>
                        <Link
                          to={`/conexion-siete/leer?u=${encodeURIComponent(issue.downloadUrl)}&t=${encodeURIComponent(issue.title || "Conexión Siete")}`}
                        >
                          <Button
                            size="sm"
                            className="bg-brand-navy hover:bg-brand-lavender text-white rounded-md normal-case shadow-none"
                          >
                            Leer
                          </Button>
                        </Link>
                        <a
                          href={issue.downloadUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex"
                        >
                          <Button
                            size="sm"
                            variant="outlined"
                            className="border-brand-lavender text-brand-navy rounded-md normal-case"
                          >
                            PDF
                          </Button>
                        </a>
                      </>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <NewsletterSection compact />
    </div>
  );
}
